import VDatePicker from './VDatePicker'
import VRangePicker from './VRangePicker'

export default {
  VDatePicker,
  VRangePicker
}
